module.exports = __webpack_public_path__ + "img/10.0b8114f8.jpg";